import React, { useState, useEffect, useRef, useMemo, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HamburgerMenu from '../../Components/HamburgerMenu/HamburgerMenu.jsx';
import Select from 'react-select';
import ReactDatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import DocumentService from '../../Services/documents.service.js';
import UserService from '../../Services/user.service.js';
import './OtherDocument.css';
import backIcon from '../../assests/images/left-arrow.png';
import calendarIcon from '../../assests/images/calendar.png';
import SubAccountantService from '../../Services/subAccountant.service.js';
import EnumsService from '../../Services/enums.service.js';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal.js'
import loadingAnimation from "../../assests/images/Animation.gif";
import { HashLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import DownloadIcon from "../../assests/images/downloadIcon.png";
import { useSignalR } from '../../Contexts/signalR.js';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service.js';
import saveIcon from "../../assests/images/save.png";
import cancelIcon from "../../assests/images/cancel.png";
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import NoDocumentsPdf from "../../assests/pdf/NoDocument.pdf";
import Iframe from 'react-iframe';
import DocumentTransferDialog from '../../Components/DocumentTransferDialog/DocumentTransferDialog.js';
import PuffLoader from "react-spinners/PuffLoader";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PostAddIcon from '@mui/icons-material/PostAdd';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
//table imports
import { Edit as EditIcon, Delete as DeleteIcon, Download as DownloadIconMui, Search as SearchIcon, CreateNewFolderOutlined as CreateNewFolderIcon } from '@mui/icons-material';
import {
    Button, Dialog, DialogTitle, DialogContent, Box, DialogActions, Typography, TextField, Checkbox,
    InputAdornment, Autocomplete, Popper, TableCell, TableContainer, TableHead, TableRow, Paper,
    Portal, ToggleButtonGroup, Switch, CircularProgress,
} from '@mui/material';
import Draggable from 'react-draggable';

import DraggableModal from '../../Components/DraggableModal/DraggableModal.js';
import dayjs, { Dayjs } from 'dayjs';
import { beautifyNumber } from '../../Utils/FormatNumber.js';
import { PDFDocument } from 'pdf-lib';
import DateInput from '../../Components/DateInput/DateInput.js';
import CustomMonthDatePicker from '../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js';
import MuiSelect from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import styled from '@mui/system/styled';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import IconButton from '@mui/material/IconButton';
import AutocompleteSelect from '../../Components/Widgets/AutocompleteSelect/AutocompleteSelect.jsx';
import OtherDocumentDataGrid from '../../Components/OtherDocuments/SubDocuments/OtherDocumentDataGrid.jsx';
import OtherDocumentDraggableDialog from '../../Components/OtherDocuments/SubDocuments/OtherDocumentDraggableDialog.jsx';
import OtherDocumentCreateModal from '../../Components/OtherDocuments/SubDocuments/OtherDocumentCreateModal.jsx';
import OtherDocumentDownloadModal from '../../Components/OtherDocuments/SubDocuments/OtherDocumentDownloadModal.jsx';
import { PermissionsContext } from '../../Contexts/Permissions.js';
import Constants from '../../assests/Constants/constants.js';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext.js';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext.js';
import NavigationButton from '../../Components/NavigationButton/NavigationButton.jsx';
import CustomBreadcrumbs from '../../Components/CustomBreadcrumbs/CustomBreadcrumbs.jsx'
import FilterMonthYearPicker from '../../Components/Widgets/CustomDates/FilterMonthYearPicker/FilterMonthYearPicker.jsx';
import headerStyles from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import pageStyles from './OtherDocument.module.scss';
import { getTypesForSection, isPermanentFileName } from '../../Utils/otherDocumentSections';
import OtherDocumentsTitlesCard from '../../Components/AccountantDetails/SubComponents/OtherDocumentsTitlesCard.jsx';
import accountantDetailsStyles from '../AccountantDetails/AccountantDetails.module.scss';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import journalFieldStyles from '../../Components/JournalEntryies/SubComponents/AddJournalEntryModal.module.scss';

const StyledListItem = styled('li')({
    '&:hover': {
        backgroundColor: '#F5F5F6', // Hover color
        cursor: 'pointer', // Optional: Changes the cursor to pointer
    },
});
const StyledPopper = styled(Popper)(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 'var(--Spacing-md, 8px)',
        background: 'var(--white, #FFF)',
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.32)',
    },
    '& .MuiAutocomplete-listbox': {
        padding: theme.spacing(1),
    },
    '& .MuiAutocomplete-option': {
        borderRadius: 'var(--Spacing-sm, 4px)',
        '&[aria-selected="true"], &.Mui-focused, &:hover': {
            background: 'var(--orange, #F9AA2A) !important',
        },
    },
}));

registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it
const StyledDialogTitle = styled(DialogTitle)({
    fontSize: '1.8rem',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#025366',
});

const StyledDialogContent = styled(DialogContent)({
    textAlign: 'center',
    padding: '20px 30px',
});

const StyledDialogActions = styled(DialogActions)({
    justifyContent: 'center',
    paddingBottom: '20px',
});

// Primary dialog action (e.g. Save) — matches the app's blue/orange action style.
const StyledButton = styled(Button)({
    margin: '0 8px',
    padding: '10px 24px',
    fontSize: '1rem',
    fontWeight: 600,
    borderRadius: '10px',
    textTransform: 'none',
    color: '#fff',
    backgroundColor: '#304FFF',
    boxShadow: '0 2px 8px rgba(48, 79, 255, 0.25)',
    transition: 'all 0.2s ease',
    '&:hover': {
        backgroundColor: '#F9AA2A',
        boxShadow: '0 4px 12px rgba(249, 170, 42, 0.35)',
    },
    '&:disabled': {
        backgroundColor: '#E0E0E0',
        color: '#BDBDBD',
        boxShadow: 'none',
    },
});

// Secondary dialog action (e.g. Close/Cancel) — neutral outlined button.
const StyledButtonSecondary = styled(Button)({
    margin: '0 8px',
    padding: '10px 24px',
    fontSize: '1rem',
    fontWeight: 600,
    borderRadius: '10px',
    textTransform: 'none',
    color: '#475569',
    backgroundColor: '#fff',
    border: '1px solid #e2e8f0',
    boxShadow: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
        backgroundColor: '#f1f5f9',
        borderColor: '#cbd5e1',
    },
});

const OptionButton = styled(Button)({
    margin: '10px 8px',
    padding: '12px 25px',
    fontSize: '1.1rem',
    textTransform: 'none',
    color: '#025366',
    backgroundColor: '#f5f5f5',
    border: '1px solid #E57C22',
    width: 'auto',  // Allows the button to shrink when there are many buttons
    maxWidth: '200px',  // Set a maximum width to ensure consistency
    flexGrow: 1,  // Allows buttons to fill available space equally
    '&:hover': {
        backgroundColor: '#E57C22',
        color: '#fff',
    },
});

const TypeComboPopper = React.forwardRef(({ direction = 'rtl', ...props }, ref) => (
    <Popper
        {...props}
        ref={ref}
        dir={direction}
        className={`${props.className || ''} ${journalFieldStyles.comboPopper}`}
        placement={direction === 'rtl' ? 'bottom-end' : 'bottom-start'}
        style={{ ...props.style, zIndex: 1600 }}
    />
));
TypeComboPopper.displayName = 'TypeComboPopper';

function Document() {
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();
    const [direction, setDirection] = useState('rtl'); // Default to 'rtl'
    const dataGridRef = useRef();
    const [date, setDate] = useState(new Date());
    const [modalVisible, setModalVisible] = useState(false);
    const [documentDate, setDocumentDate] = useState(new Date());
    const [title, setTitle] = useState('');
    const [documentType, setDocumentType] = useState('');
    const [documentTypeFetch, setDocumentTypeFetch] = useState('');
    const [documents, setDocuments] = useState([]);
    const [fileTransported, setFileTransported] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [okMessage, setOkMessage] = useState('');
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    const [data, setData] = useState([]);
    const [client, setClient] = useState(null);
    const [type, setType] = useState('');
    const [sortByTitleAsc, setSortByTitleAsc] = useState(true); // Sort by title ascending by default
    const [sortByDateAsc, setSortByDateAsc] = useState(false); // Sort by title ascending by default
    const [searchQuery, setSearchQuery] = useState('');
    const [currentSort, setCurrentSort] = useState("date");
    const [sortByAmountAsc, setSortByAmountAsc] = useState(true); // Sort by amount ascending by default
    const modalCreateDocumentRef = useRef(); // Reference to the modal content
    const [otherDocumentsOptions, setOtherDocumentsOptions] = useState([]);
    const [selectOtherDocumentsOptions, setSelectOtherDocumentsOptions] = useState([]);
    // Full list for create / transfer / edit — not filtered by תיק קבע
    const [allOtherDocumentsOptions, setAllOtherDocumentsOptions] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('language') || 'he');
    const location = useLocation();
    const [editingRow, setEditingRow] = useState(null);
    const [editedItem, setEditedItem] = useState({});
    const [editedProvider, setEditedProvider] = useState(false);
    const [originalProviderId, setOriginalProviderId] = useState('');
    const [sortDate, setSortDate] = useState(new Date());
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [itemIdToDelete, setItemIdToDelete] = useState(null);
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(new Date()); // Start date for range
    const [endDate, setEndDate] = useState(new Date()); // End date for range
    const [isRange, setIsRange] = useState(false); // Flag to toggle between single date and range
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [downloadStartDate, setDownloadStartDate] = useState(null); // Start date for range
    const [downloadEndDate, setDownloadEndDate] = useState(null);
    const [downloadAmount, setDownloadAmount] = useState();
    const [downloadOtherDocumentType, setDownloadOtherDocumentType] = useState([]);
    const [shouldDelete, setShouldDelete] = useState(false);
    const [deleteDto, setDeleteDto] = useState({});
    const [deleteDtos, setDeleteDtos] = useState([]);
    const [multiTransferItems, setMultiTransferItems] = useState(null);
    const { documentUpdate } = useSignalR();
    const [statusCheck, setStatusCheck] = useState(false);
    const [isClientDataFetched, setIsClientDataFetched] = useState(false);
    const [addOtherDocumentType, setAddOtherDocumentType] = useState(false);
    const [addCategoryModalOpen, setAddCategoryModalOpen] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState('');
    const [newCategoryHidden, setNewCategoryHidden] = useState(false);
    const [newCategoryTitleId, setNewCategoryTitleId] = useState('');
    const [addTitleModalOpen, setAddTitleModalOpen] = useState(false);
    const [newTitleName, setNewTitleName] = useState('');
    const [newTitleHidden, setNewTitleHidden] = useState(false);
    const [assignTitleModalOpen, setAssignTitleModalOpen] = useState(false);
    const [assignTypeIds, setAssignTypeIds] = useState([]);
    const [assignTargetTitleId, setAssignTargetTitleId] = useState('');
    const [manageTitlesOpen, setManageTitlesOpen] = useState(false);
    const [filterByDateRange, setFilterByDateRange] = useState(false);
    const [filterStartDate, setFilterStartDate] = useState(() => {
        const now = new Date();
        return new Date(Date.UTC(now.getFullYear(), 0, 10));
    });
    const [filterEndDate, setFilterEndDate] = useState(() => {
        const now = new Date();
        return new Date(Date.UTC(now.getFullYear(), now.getMonth(), 10));
    });
    const [editedPopupItem, setEditedPopupItem] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: 'uploadNumber', direction: 'descending', type: 'number' });
    const [focused, setFocused] = useState(false);
    const [openInlineEditModal, setOpenInlineEditModal] = useState(false);
    const [currentRowData, setCurrentRowData] = useState(null);
    const customScrollbarRef = useRef();
    const tableContainerRef = useRef();
    const [calculatedWidth, setCalculatedWidth] = useState('70%');
    const [selectedRows, setSelectedRows] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    const [openOptions, setOpenOptions] = useState(false);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [container] = useState(() => document.createElement('div'));
    const nodeRef = useRef(null);
    const [showPdfIframe, setShowPdfIframe] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);
    const { userTypeContext, permissionsState, clientPermissionsState } = useContext(PermissionsContext);
    const isClient = useMemo(() => {
        return userTypeContext?.toString() === Constants.UserType.Client;
    }, [userTypeContext]);
    const isAccountantOrSubAccountant = useMemo(() => {
        const ut = userTypeContext?.toString();
        return ut === Constants.UserType.Accountant || ut === Constants.UserType.SubAccountant;
    }, [userTypeContext]);
    const hideStatusBadge = clientPermissionsState?.CantSeeStatusDocuments && isClient;
    const { goBack } = useContext(NavHistoryContext);

    const { setMenuProps } = useHamburgerMenu();
    useEffect(() => {
        setMenuProps({ client });        
        }, [client, setMenuProps]);

    const inputPropsStyle = {
        disableUnderline: true,
        className: `custom-input-box-sizing-toggle ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
        sx: {
            height: '48px',
            padding: '0 10px',
            borderRadius: '8px',
            background: '#F5F5F6',
            border: '1px solid transparent',
            '&:focus-within': {
                border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
            },
        },
    };

    const inputStyle = {
        style: {
            textAlign: direction === 'ltr' ? 'left' : 'right',
        },
    };

    useEffect(() => {
        // Update direction based on the current language
        if (i18n.language === 'he' || i18n.language === 'ar') {
            setDirection('rtl');
        } else {
            setDirection('ltr');
        }
    }, [i18n.language]);

    const handleCustomScroll = (e) => {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    const handleTableScroll = (e) => {
        if (customScrollbarRef.current) {
            customScrollbarRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    const synchronizeScroll = () => {
        if (tableContainerRef.current && customScrollbarRef.current) {
            customScrollbarRef.current.scrollLeft = tableContainerRef.current.scrollLeft;

        }
    };
    const handleDeleteClick = (itemId, documentType) => {
        setItemIdToDelete(itemId);
        setDocumentTypeFetch(documentType);
        setIsModalVisible(true);
    };

    const handleRadioChange = (e) => {
        if (e.target.value == 'done') {
            setStatusCheck(true);
        }
        else if (e.target.value == 'notDone') {
            setStatusCheck(false);
        }
        setEditedItem({ ...editedItem, ["status"]: e.target.value });
    };

    const handleConfirmDelete = async () => {
        // Perform delete operation
        setLoading(true);
        try {
            // Call the DeleteDocument function from DocumentService with the item's id
            const response = await DocumentService.DeleteDocument(type, itemIdToDelete, token);
            if (response.ok) {
                // Handle successful deletion, e.g., by updating your UI
                toast.success(t('documentDeleteSuccess'));
                fetchByDocumentType(documentTypeFetch);
            } else {
                // Handle any errors or display a message
                const errorResponse = await response.json();
                toast.error(t('documentDeleteError'));
                console.error('Error deleting document:', errorResponse);
            }
        } catch (error) {
            toast.error(t('documentDeleteError'));
            console.error('Error deleting document:', error);
        }
        setIsModalVisible(false);
        setLoading(false);
    };

    const handleDoneClick = async (itemId) => {
        setLoading(true);
        try {
            const response = await ClientDocumentCountService.removeDocumentByTypeAndId(client.caseId, client.accountantId, type, itemId, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token);

                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };

    const handleNotDoneClick = async (itemId) => {
        setLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentByTypeAndId(client.caseId, client.accountantId, type, itemId, token)
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };

    const fetchDocumentsNotification = async (client, token) => {

        const documentCounts = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);

        // Enrich clients with their total document counts
        const enrichedClient = {
            ...client,
            totalCounts: documentCounts.totalCounts || 0, // Default to 0 if no matching count is found
            documentCounts: documentCounts.documentCounts || {},
            documentIds: documentCounts.documentIds || {},
        };

        setClient(enrichedClient);
    }


    const handleEdit = (item, isPopup = true) => {
        setEditingRow(item.id);
        item.docType = 'OtherDocuments';
        setEditedItem({ ...item }); // create a copy of the item for editing
        let statusChecked = client.documentIds.otherDocuments.includes(item.id);
        setStatusCheck(!statusChecked);
        setEditedPopupItem(isPopup);

        // Find the index of the item in filteredAndSortedData
        const index = filteredAndSortedData.findIndex((i) => i.id === item.id);
        setCurrentIndex(index);
    };
    const handleNext = () => {
        if (currentIndex < filteredAndSortedData.length - 1) {
            const nextIndex = currentIndex + 1;
            setCurrentIndex(nextIndex);
            setEditedItem({ ...filteredAndSortedData[nextIndex] });
            setEditingRow(filteredAndSortedData[nextIndex].id); // Update editingRow if needed
        }
    };

    const handlePrevious = () => {
        if (currentIndex > 0) {
            const prevIndex = currentIndex - 1;
            setCurrentIndex(prevIndex);
            setEditedItem({ ...filteredAndSortedData[prevIndex] });
            setEditingRow(filteredAndSortedData[prevIndex].id); // Update editingRow if needed
        }
    };

    const handleChange = (e, field) => {
        setEditedItem({ ...editedItem, [field]: e.target.value });
    };

    const handleDateChange = (e, field) => {
        setEditedItem({ ...editedItem, [field]: e });
    };

    const handleUpdate = async (itemId) => {
        setLoading(true);

        try {
            delete editedItem.documentUrl;

            const response = await DocumentService.UpdateDocument(type, token, editedItem);
            if (editedItem.status == 'done') {
                await handleDoneClick(editedItem.id)
            }
            else if (editedItem.status == 'notDone') {
                await handleNotDoneClick(editedItem.id)
            }
            if (response.ok) {
                fetchByDocumentType(editedItem.documentType);
                toast.success(t('documentUpdateSuccess'));
            } else {
                const errorText = await response.text();
                toast.error(t('documentUpdateError'));
                // Handle error
            }
        } catch (error) {
            toast.error(t('documentUpdateError'));
            // Handle error
        }
        setEditingRow(null);
        setEditedItem({});
        setLoading(false);
    };

    const [isPermenantCase, setIsPermenantCase] = useState(false);
    const [currentTitleId, setCurrentTitleId] = useState(null);
    const [currentTitleName, setCurrentTitleName] = useState('');
    const [otherDocumentsTitles, setOtherDocumentsTitles] = useState([]);

    const handleUpdateV2 = async (editedItem) => {
        setLoading(true);

        try {
            delete editedItem.documentUrl;

            const response = await DocumentService.UpdateDocument(type, token, editedItem);
            if (editedItem.status == 'done') {
                await handleDoneClick(editedItem.id)
            }
            else if (editedItem.status == 'notDone') {
                await handleNotDoneClick(editedItem.id)
            }
            if (response.ok) {
                fetchByDocumentType(editedItem.documentType);
                toast.success(t('documentUpdateSuccess'));
            } else {
                const errorText = await response.text();
                toast.error(t('documentUpdateError'));
                // Handle error
            }
        } catch (error) {
            toast.error(t('documentUpdateError'));
            // Handle error
        }
        setEditingRow(null);
        setEditedItem({});
        setLoading(false);
    };

    const handleCancel = () => {
        setEditingRow(null);
        setEditedItem({});
    };

    const handleDocumentUpload = (event) => {

        setDocuments(Array.from(event.target.files));
    };

    const formatDate = dateString => {
        const date = new Date(dateString);
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const closeCreateModal = (e) => {
        // Check if the clicked element is the same as the event handler's element
        if (modalCreateDocumentRef.current && !modalCreateDocumentRef.current.contains(e.target)) {
            handleClose();
        }
    }

    const handleClose = async () => {
        setModalVisible(false);
        setErrorMessage('');
        setOkMessage('');
        setTitle("");
        setDocumentType("")
        setDocuments("")
        setAddOtherDocumentType(false);
    }
    const openAddCategoryModal = () => {
        setNewCategoryTitleId(currentTitleId || '');
        setAddCategoryModalOpen(true);
    };

    const closeAddCategoryModal = () => {
        setAddCategoryModalOpen(false);
        setNewCategoryName('');
        setNewCategoryHidden(false);
        setNewCategoryTitleId('');
    };

    const currentTitle = useMemo(
        () => otherDocumentsTitles.find((title) => title.id === currentTitleId) || null,
        [otherDocumentsTitles, currentTitleId]
    );

    const titleNameByType = useMemo(() => {
        const titleNames = new Map(otherDocumentsTitles.map((title) => [title.id, title.name]));
        const result = {};
        allOtherDocumentsOptions.forEach((type) => {
            if (type?.titleId && titleNames.has(type.titleId)) {
                result[type.name] = titleNames.get(type.titleId);
            }
        });
        return result;
    }, [otherDocumentsTitles, allOtherDocumentsOptions]);

    const refreshSection = async () => {
        const currentType = (documentTypeFetch && documentTypeFetch !== t('All')) ? documentTypeFetch : '';
        const sectionTypes = await fetchEnums(user, token, client, currentType, isPermenantCase);
        if (!sectionTypes) return;
        const stillInSection = currentType && sectionTypes.some((type) => type.name === currentType);
        await fetchByDocumentType(stillInSection ? currentType : t('All'), sectionTypes);
    };

    const reloadTitles = async () => {
        try {
            const response = await EnumsService.GetOtherDocumentsTitlesByAccountantId(user.accountantId, token);
            if (response.ok) {
                const titles = await response.json();
                setOtherDocumentsTitles(Array.isArray(titles) ? titles : []);
            }
        } catch (error) {
            console.error('Error reloading titles:', error);
        }
    };

    const handleConvertPermanentFile = async () => {
        setLoading(true);
        try {
            const response = await EnumsService.EnsurePermanentFileTitle(user.accountantId, true, token);
            if (response.ok) {
                const title = await response.json();
                toast.success(t('PermanentFileConvertedSuccessfully'));
                setCurrentTitleId(title.id);
                setCurrentTitleName(title.name);
                const sectionTypes = await fetchEnums(user, token, client, '', false, title.id);
                if (sectionTypes) {
                    await fetchByDocumentType(t('All'), sectionTypes);
                }
            } else {
                const errorText = await response.text();
                toast.error(`${t('TitleAddError')}: ${errorText}`);
            }
        } catch (error) {
            console.error('Error converting permanent file to a title:', error);
            toast.error(t('TitleAddError'));
        }
        setLoading(false);
    };

    const closeAddTitleModal = () => {
        setAddTitleModalOpen(false);
        setNewTitleName('');
        setNewTitleHidden(false);
    };

    const handleAddTitleSave = async () => {
        const trimmedName = newTitleName.trim();
        if (!trimmedName) return;
        setLoading(true);
        try {
            const response = await EnumsService.AddOtherDocumentsTitle(user.accountantId, trimmedName, token, newTitleHidden);
            if (response.ok) {
                toast.success(t('TitleAddedSuccessfully'));
                closeAddTitleModal();
                await fetchEnums(user, token, client, documentTypeFetch !== t('All') ? documentTypeFetch : '', isPermenantCase);
            } else {
                const errorText = await response.text();
                toast.error(`${t('TitleAddError')}: ${errorText}`);
            }
        } catch (error) {
            console.error('Error adding title:', error);
            toast.error(t('TitleAddError'));
        }
        setLoading(false);
    };

    const openAssignTitleModal = () => {
        setAssignTypeIds([]);
        setAssignTargetTitleId(currentTitleId || '');
        setAssignTitleModalOpen(true);
    };

    const closeAssignTitleModal = () => {
        setAssignTitleModalOpen(false);
        setAssignTypeIds([]);
        setAssignTargetTitleId('');
    };

    const handleAssignTitleSave = async () => {
        if (assignTypeIds.length === 0) return;
        setLoading(true);
        try {
            const response = await EnumsService.AssignTypesToOtherDocumentsTitle(
                user.accountantId,
                assignTargetTitleId || null,
                assignTypeIds,
                token
            );
            if (response.ok) {
                toast.success(t('TypesAssignedSuccessfully'));
                closeAssignTitleModal();
                await refreshSection();
            } else {
                const errorText = await response.text();
                toast.error(`${t('TypesAssignError')}: ${errorText}`);
            }
        } catch (error) {
            console.error('Error assigning types to title:', error);
            toast.error(t('TypesAssignError'));
        }
        setLoading(false);
    };

    const handleToggleCurrentTitleHidden = async () => {
        if (!currentTitle) return;
        const hidden = !currentTitle.hiddenFromClient;
        setLoading(true);
        try {
            const response = await EnumsService.SetOtherDocumentsTitlesHidden(user.accountantId, [currentTitle.id], hidden, token);
            if (response.ok) {
                setOtherDocumentsTitles((prev) =>
                    prev.map((title) => (title.id === currentTitle.id ? { ...title, hiddenFromClient: hidden } : title))
                );
                toast.success(t(hidden ? 'TitlesHiddenSuccessfully' : 'TitlesShownSuccessfully'));
            } else {
                const errorText = await response.text();
                toast.error(`${t('TitleUpdateError')}: ${errorText}`);
            }
        } catch (error) {
            console.error('Error updating title visibility:', error);
            toast.error(t('TitleUpdateError'));
        }
        setLoading(false);
    };

    const handleAddCategorySave = async () => {
        const trimmedName = newCategoryName.trim();
        if (!trimmedName) {
            return;
        }
        setLoading(true);
        try {
            const response = await EnumsService.AddOtherDocumentsType(
                user.accountantId,
                trimmedName,
                token,
                newCategoryHidden,
                newCategoryTitleId || null
            );
            if (response.ok) {
                toast.success(t('CategoryAddedSuccessfully'));
                closeAddCategoryModal();
                const currentType = (documentTypeFetch && documentTypeFetch !== t('All')) ? documentTypeFetch : '';
                await fetchEnums(user, token, client, currentType, isPermenantCase);
            } else {
                const errorText = await response.text();
                toast.error(`${t('CategoryAddError')}: ${errorText}`);
            }
        } catch (error) {
            console.error('Error adding category:', error);
            toast.error(t('CategoryAddError'));
        }
        setLoading(false);
    };

    const allFieldsFilled = documentType && documents && documents.length > 0
    const handleNewDocumentsTypeSave = async () => {
        setLoading(true);
        try {
            let ResponseOk = true;
            // Make the account card API call if fields are valid
            const response1 = await EnumsService.AddOtherDocumentsType(user.accountantId, documentType, token, false, currentTitleId || null);
            ResponseOk = response1.ok;
            if (!response1.ok) {
                const errorText = await response1.text();
                console.error("Error adding OtherDocuments:", errorText);
                toast.error(`${t("Error on save OtherDocumentsType data")}: ${errorText}`);
            }

            // If any API call was successful, fetch enums
            if (ResponseOk) {
                toast.info(t("OtherDocumentsType data has been saved successfully"));
                await fetchEnums(user, token, client);
            }

        } catch (error) {
            toast.error(t("Error on save OtherDocumentsType data"));
            console.error(error);
        }
        setLoading(false);
    };
    const handleSave = async (item, documents) => {
        setLoading(true);

        try {
            if (item?.isNewCategory && item.documentType) {
                const alreadyExists = allOtherDocumentsOptions.some(
                    (opt) => opt.name?.trim() === item.documentType.trim()
                );
                if (!alreadyExists) {
                    const categoryResponse = await EnumsService.AddOtherDocumentsType(
                        user.accountantId,
                        item.documentType,
                        token,
                        !!item.hiddenFromClient,
                        currentTitleId || null
                    );
                    if (!categoryResponse.ok) {
                        const errorText = await categoryResponse.text();
                        toast.error(`${t('CategoryAddError')}: ${errorText}`);
                        setLoading(false);
                        return;
                    }
                    toast.success(t('CategoryAddedSuccessfully'));
                }
            }

            // Multi-transfer: one shared form config applied per source item; delete only after each succeeds
            if (Array.isArray(multiTransferItems) && multiTransferItems.length > 0) {
                let successCount = 0;
                let deletedCount = 0;
                const failedIds = [];

                for (const transferItem of multiTransferItems) {
                    const itemFiles = Array.isArray(transferItem.files)
                        ? transferItem.files
                        : (transferItem.files ? [transferItem.files] : []);

                    if (!itemFiles.length) {
                        failedIds.push(transferItem.dto?.id || transferItem.idToDelete || '?');
                        continue;
                    }

                    const formData = new FormData();
                    formData.append('CaseId', client.caseId);
                    formData.append('AccountantId', user.accountantId);
                    formData.append('Title', item.title);
                    formData.append('DocumentType', item.documentType);
                    formData.append('DocumentDate', new Date(documentDate).toISOString());
                    formData.append('DocumentFileType', type);
                    itemFiles.forEach((document) => {
                        formData.append('documents', document, document.name);
                    });

                    try {
                        const response = await DocumentService.UploadDocument(type, formData, token);
                        if (response.ok) {
                            successCount += 1;
                            if (transferItem.idToDelete && transferItem.fileTypeToDelete) {
                                try {
                                    const deleteResponse = await DocumentService.DeleteDocument(
                                        transferItem.fileTypeToDelete,
                                        transferItem.idToDelete,
                                        token
                                    );
                                    if (deleteResponse.ok) {
                                        deletedCount += 1;
                                    } else {
                                        const errorText = await deleteResponse.text();
                                        toast.error(t('ErrorDeletingSourceDocument', { errorText }));
                                    }
                                } catch (deleteError) {
                                    toast.error(t('ErrorDeletingSourceDocument', { errorText: deleteError.message }));
                                }
                            }
                        } else {
                            failedIds.push(transferItem.dto?.id || transferItem.idToDelete || '?');
                        }
                    } catch {
                        failedIds.push(transferItem.dto?.id || transferItem.idToDelete || '?');
                    }
                }

                if (addOtherDocumentType) {
                    await handleNewDocumentsTypeSave();
                }

                toast.info(
                    t('MultiTransferSummary', {
                        selected: multiTransferItems.length,
                        success: successCount,
                        failed: failedIds.length,
                        deleted: deletedCount,
                    }),
                    { autoClose: 8000 }
                );
                if (failedIds.length > 0) {
                    toast.error(t('MultiTransferFailedDocuments', { ids: failedIds.join(', ') }), {
                        autoClose: 10000,
                    });
                }

                setMultiTransferItems(null);
                setShouldDelete(false);
                setDeleteDto({});
                setDeleteDtos([]);
            } else {
                const formData = new FormData();
                formData.append('CaseId', client.caseId);
                formData.append('AccountantId', user.accountantId);
                formData.append('Title', item.title);
                formData.append('DocumentType', item.documentType);
                formData.append('DocumentDate', new Date(documentDate).toISOString());
                formData.append('DocumentFileType', type);
                documents.forEach(document => {
                    formData.append("documents", document, document.name);
                });

                const response = await DocumentService.UploadDocument(type, formData, token);
                if (response.ok) {
                    if (addOtherDocumentType) {
                        await handleNewDocumentsTypeSave();
                    }
                    if (shouldDelete) {
                        await deleteAfterTransfer();
                    }
                    toast.success(t('documentUploadedSuccess'));
                } else {
                    const errorText = await response.text();
                    toast.error(t('documentUploadError') + `: ${errorText}`);
                }
            }
        } catch (error) {
            toast.error(t('documentUploadError'));
        }

        setTitle("");
        setDocumentType("");
        setDocuments([]);
        setAddOtherDocumentType(false);
        setModalVisible(false);
        if (item?.isNewCategory) {
            await fetchEnums(user, token, client, item.documentType, isPermenantCase);
        }
        fetchByDocumentType(item.documentType);
        fetchDocumentsNotification(client, token);
        setLoading(false);
    };


    const [subAccountants, setSubAccountants] = useState([]);
    const [subAccountantOptions, setSubAccountantOptions] = useState([]);
    const [accountant, setAccountant] = useState({});

    const fetchEnums = async (user, token, client, documentType, permenantCase = false, titleId = currentTitleId) => {
        setLoading(true);
        let sectionTypes = null;
        try {
            const [otherDocumentsResponse, titlesResponse] = await Promise.all([
                EnumsService.GetOtherDocumentsTypesByAccountantId(user.accountantId, token),
                EnumsService.GetOtherDocumentsTitlesByAccountantId(user.accountantId, token).catch(() => null),
            ]);
            const otherDocumentsData = await otherDocumentsResponse.json();
            const titlesData = titlesResponse?.ok ? await titlesResponse.json() : [];
            const titles = Array.isArray(titlesData) ? titlesData : [];
            setOtherDocumentsTitles(titles);

            const activeTitle = titleId ? titles.find((title) => title.id === titleId) : null;
            const isPermanent = !activeTitle && ((documentType && isPermanentFileName(documentType)) || !!permenantCase);
            setIsPermenantCase(isPermanent);
            if (titleId && !activeTitle) {
                setCurrentTitleId(null);
                setCurrentTitleName('');
            } else if (activeTitle) {
                setCurrentTitleName(activeTitle.name);
            }

            const filteredOtherDocumentsData = getTypesForSection(otherDocumentsData, titles, {
                titleId: activeTitle ? activeTitle.id : null,
                isPermanent,
            });
            sectionTypes = filteredOtherDocumentsData;

            // Browse filter stays scoped to תיק קבע / regular; create & transfer use all types
            setSelectOtherDocumentsOptions(filteredOtherDocumentsData);
            setAllOtherDocumentsOptions(otherDocumentsData);
            const otherDocumentsOptions = [{ name: t('Add New Document Name'), value1: 'AddItem' }, ...otherDocumentsData];
            setOtherDocumentsOptions(otherDocumentsOptions); // Assuming codeIdData is already in the correct format
            // Set default to "All" if no documentType is specified
            setDocumentTypeFetch(documentType ? documentType : t('All'))
            setIsClientDataFetched(true);

            const result2 = await SubAccountantService.GetSubAccountantByAccountantId(token, user.accountantId);
            const accountantResult = await SubAccountantService.GetAccountantById(token, user.accountantId);
            const enhancedAccountantResult = {
                ...accountantResult,
                subAccountantId: accountantResult.accountantId, // Add subAccountantId as same as accountantId
            };
            setAccountant(enhancedAccountantResult);




            if (result2) {
                const combinedSubAccountants = [enhancedAccountantResult, ...result2];

                if (client) {
                    combinedSubAccountants.push({
                        subAccountantId: client.caseId,
                        name: client.name,
                    });
                }

                setSubAccountants(combinedSubAccountants);

                const combinedOptions = combinedSubAccountants.map((acc) => ({
                    value: acc.subAccountantId,
                    label: acc.name,
                }));

                setSubAccountantOptions(combinedOptions);
            } else {
                toast.error(t('fetchSubAccountantsDataError'));
            }
        } catch (error) {
            console.error(error);
            toast.error(t('fetchEnumsError'), error);
            // Handle the error appropriately
            setIsClientDataFetched(false)
        }
        setLoading(false);
        return sectionTypes;
    };


    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const currentUser = await UserService.getCurrentUser();
                const currentToken = await UserService.getCurrentToken();
                if (currentUser && currentToken) {
                    setUser(currentUser);
                    setToken(currentToken);
                    // also here what we added if not null put the name in fetchByDocumentType()
                    // if (location.state?.subItem) {
                    //     fetchByDocumentType(location.state.subItem);
                    // }
                    // Get client data from location.state
                    if (location.state && location.state.client && location.state.type) {
                        await fetchDocumentsNotification(location.state.client, currentToken);
                        setType(location.state.type)
                        // setClient(location.state.client);
                    }

                    if (location.state && location.state.isPermenantCase) {
                        setIsPermenantCase(location.state.isPermenantCase);
                    }

                    const stateTitleId = location.state?.titleId || null;
                    setCurrentTitleId(stateTitleId);
                    setCurrentTitleName(location.state?.titleName || '');

                    let documentType = location.state?.subItem || '';


                    await fetchEnums(currentUser, currentToken, location.state.client, documentType, location.state.isPermenantCase, stateTitleId);
                    // Fetch financial data for the current date on initial load only
                }
                else {
                    navigate("/login");
                }


            } catch (error) {
                // Handle error - maybe navigate to login or show a message
            }
            setLoading(false);
        };

        setIsClientDataFetched(false);
        fetchUserData();

    }, [location.state.client]);

    useEffect(() => {
        // To handle multiple updates efficiently, consider iterating over documentUpdate keys
        Object.keys(documentUpdate).forEach(updateCaseId => {
            const update = documentUpdate[updateCaseId];

            if (client?.caseId === updateCaseId) { // Check if the client's caseId matches the update's caseId
                const updatedClients = {
                    ...client,
                    totalCounts: update.totalCounts, // Update totalCounts from documentUpdate
                    documentIds: update.documentsIds,
                    documentsCount: update.documentsCount
                };
                setClient(updatedClients); // Update the state with the modified lzist
            }

        });
    }, [documentUpdate]);

    const fetchByDocumentType = async (DocumentType, sectionTypes = selectOtherDocumentsOptions) => {
        setLoading(true);
        setDocumentTypeFetch(DocumentType);
        try {
            // If "All" is selected, fetch documents from all types
            if (DocumentType === t('All') || DocumentType === 'All' || !DocumentType) {
                // Check if we have document types available
                if (!sectionTypes || sectionTypes.length === 0) {
                    setData([]);
                    setLoading(false);
                    return;
                }
                
                // Fetch documents from all document types
                const allDocumentsPromises = sectionTypes.map(docType => 
                    DocumentService.GetOtherDocumentbyType(
                        type,
                        client.caseId,
                        docType.name,
                        token
                    )
                );

                const allResponses = await Promise.all(allDocumentsPromises);
                
                // Collect all documents from all types
                const allDocuments = [];
                for (const response of allResponses) {
                    if (response.ok) {
                        const data = await response.json();
                        if (data && data.length > 0) {
                            allDocuments.push(...data);
                        }
                    }
                }

                // Remove duplicates based on document ID
                const uniqueDocuments = allDocuments.reduce((acc, current) => {
                    const exists = acc.find(doc => doc.id === current.id);
                    if (!exists) {
                        acc.push(current);
                    }
                    return acc;
                }, []);

                setData(uniqueDocuments);
            } else {
                // Fetch documents for a specific type
                const response = await DocumentService.GetOtherDocumentbyType(type, client.caseId, DocumentType, token)
                if (response.ok) {
                    const data = await response.json(); // Parse the JSON in the response
                    setData(data);
                    // toast.success(t('fetchDocumentsSuccess'));
                } else {
                    const errorText = await response.text();
                    console.error(t('fetchDocumentsError'), errorText);

                    // Show an error toast message
                    toast.error(`${t('fetchDocumentsError')}: ${errorText}`);
                }
            }
        } catch (error) {
            console.error(t('fetchDocumentsError'), error);

            toast.error(`${t('fetchDocumentsError')}: ${error}`);

        } finally {
            setLoading(false); // Stop loading regardless of the outcome
        }
    };


    useEffect(() => {
        if (user && token && client && type && isClientDataFetched) {
            // If documentTypeFetch is not set, default to "All"
            const typeToFetch = documentTypeFetch || t('All');
            fetchByDocumentType(typeToFetch);
        }
    }, [isClientDataFetched]);


    const CustomDownloadInput = React.forwardRef(({ value, placeholderText, onClick }, ref) => {
        return (
            <button className="download-document-custom-input" onClick={onClick} ref={ref}>
                {value || placeholderText}
            </button>
        );
    });


    const filteredAndSortedData = useMemo(() => {
        if (data.length < 0) {
            return;
        }
        const rangeStart = new Date(filterStartDate.getFullYear(), filterStartDate.getMonth(), 1);
        const rangeEnd = new Date(filterEndDate.getFullYear(), filterEndDate.getMonth() + 1, 1);
        const sortedData = data.filter((item) => {
            const query = searchQuery.toLowerCase();
            const matchesSearch = (
                item?.title?.toLowerCase()?.includes(query) || // Safely access item.title
                formatDate(item?.documentDate)?.includes(query) ||
                item?.uploadNumber?.toString()?.includes(query)
            );
            if (!matchesSearch || !filterByDateRange) return matchesSearch;
            const docDate = item?.documentDate ? new Date(item.documentDate) : null;
            return !!docDate && !Number.isNaN(docDate.getTime()) && docDate >= rangeStart && docDate < rangeEnd;
        });
        if (sortConfig.key) {
            sortedData.sort((a, b) => {
                if (sortConfig.type === 'newest') {
                    const highlightedIds = client.documentIds.otherDocuments;
                    const aIsHighlighted = highlightedIds.includes(a.id);
                    const bIsHighlighted = highlightedIds.includes(b.id);

                    if (sortConfig.direction === 'ascending') {
                        // Ascending: Non-highlighted (older) items first
                        if (!aIsHighlighted && bIsHighlighted) {
                            return -1; // 'a' should come before 'b' (a is older, hence "lower")
                        } else if (aIsHighlighted && !bIsHighlighted) {
                            return 1;  // 'b' should come before 'a' (b is older, hence "lower")
                        }
                    } else {
                        // Descending: Highlighted (newer) items first
                        if (aIsHighlighted && !bIsHighlighted) {
                            return -1; // 'a' should come before 'b' (a is newer, hence "higher")
                        } else if (!aIsHighlighted && bIsHighlighted) {
                            return 1;  // 'b' should come before 'a' (b is newer, hence "higher")
                        }
                    }
                } else {
                    const aValue = a[sortConfig.key] || ""; // Default to empty string if null or undefined
                    const bValue = b[sortConfig.key] || ""; // Default to empty string if null or undefined
                    if (sortConfig.type === 'number') {
                        return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
                    } else if (sortConfig.type === 'date') {
                        return sortConfig.direction === 'ascending' ? new Date(aValue) - new Date(bValue) : new Date(bValue) - new Date(aValue);
                    } else { // default to string comparison
                        return sortConfig.direction === 'ascending' ? aValue?.localeCompare(bValue) : bValue?.localeCompare(aValue);
                    }
                }
            });
        }

        return sortedData;
    }, [data, searchQuery, sortConfig, filterByDateRange, filterStartDate, filterEndDate]);

    const handleFilterDateChange = (setter, current) => (newValue, part) => {
        const picked = new Date(newValue);
        const updated = part === 'year'
            ? new Date(Date.UTC(picked.getFullYear(), current.getMonth(), 10))
            : new Date(Date.UTC(current.getFullYear(), picked.getMonth(), 10));
        setter(updated);
    };

    const handleGoBack = () => {
        // Navigate back to the previous page using React Router
        if (client) {
            // navigate('/client-details', { state: { client } });
            goBack()
        }
    };


    const setOpenOption = () => setOpenOptions(true);
    const closeOptions = () => {
        handleDeselect(selectedRows);
        setOpenOptions(false);
        setSelectedRows([]); // Unselect all rows
        setIsAllSelected(false); // Uncheck the "Select all" checkbox
    };

    const handleDeselect = (ids) => {
        if (dataGridRef.current) {
            dataGridRef.current.deselectRows(ids); // Call deselectRow on the ref
        }
    };
    const isSelected = (id) => selectedRows.indexOf(id) !== -1;

    const handleSelectRow = (event, item) => {
        const selectedIndex = selectedRows.findIndex(selected => selected.id === item.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, item);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1),
            );
        }

        setSelectedRows(newSelected);
    };


    const handleSelectAllClick = (event) => {
        const checked = event.target.checked;
        setIsAllSelected(checked);

        if (checked) {
            const newSelecteds = filteredAndSortedData.map((item) => item.id);
            setSelectedRows(newSelecteds);
            setAllSelected(true);
        } else {
            setSelectedRows([]);
            setAllSelected(false);
        }
    };

    const handleOptionSelect = async (option) => {
        if (hideStatusBadge) {
            closeOptions();
            return;
        }
        if (selectedRows && selectedRows.length > 0) {
            if (option === 'done') {
                await handleDoneIdsClick(selectedRows);
            } else if (option === 'notDone') {
                await handleNotDoneIdsClick(selectedRows);
            }
        }

        closeOptions();
    };

    const handleDoneIdsClick = async (itemIds) => {
        setLoading(true);
        try {

            const response = await ClientDocumentCountService.removeDocumentsByTypeAndIds(client.caseId, client.accountantId, type, itemIds, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token);

                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentsNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentsNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };

    const handleNotDoneIdsClick = async (itemIds) => {
        setLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentsByTypeAndIds(client.caseId, client.accountantId, type, itemIds, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token);

                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentsNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentsNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };

    const handleDownloadStartDateChange = (date) => {
        const newDate = new Date(date.getFullYear(), date.getMonth(), 10);
        setDownloadStartDate(newDate);
    };

    const handleDownloadEndDateChange = async (date) => {
        const endDate = new Date(date.getFullYear(), date.getMonth(), 10);
        setDownloadEndDate(endDate);
    };


    async function fetchDataOnDateRangeChange(startDate, endDate) {

        setLoading(true)
        const formattedStartDate = startDate.toISOString();
        const formattedEndDate = endDate.toISOString();

        try {
            const response = await DocumentService.GetDocumentbyDateRange(type, client.caseId, formattedStartDate, formattedEndDate, token)
            if (response.ok) {
                const data = await response.json(); // Parse the JSON in the response
                setData(data);
                // toast.success(t('documentFetchSuccess'));
            } else {
                const errorText = await response.text();
                toast.error(t('documentFetchError', { errorText }));
            }
        } catch (error) {
            toast.error(t('documentFetchError', { errorText: error.message }));
        }

        setLoading(false)
    }

    const handleDownloadDocuments = async (downloadData) => {
        setLoading(true);
        try {
            const dto = {
                CaseId: client.caseId,
                Date: downloadData.downloadStartDate,
                EndDate: downloadData.downloadEndDate,
                OtherDocumentsTypeIds: downloadData.documentTypes,
            };

            const blob = await DocumentService.DownloadCustomDocuments(type, token, dto); // Assuming you have token state or prop for authorization
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'documents.zip'); // or any other extension
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            toast.success(t('documentDownloadSuccess'));
        } catch (error) {
            console.error('Error downloading documents:', error);
            toast.error(t('documentDownloadError', { errorText: error.message }));
        }
        setDownloadStartDate(null);
        setDownloadEndDate(null);
        setDownloadAmount();
        setDownloadOtherDocumentType([]);
        setShowDownloadModal(false)
        setLoading(false);
    };

    const handleDownloadMergedDocuments = async () => {
        if (selectedRows.length === 0) {
            toast.info(t('PleaseSelectOptionForSelectedRows'));
            return;
        }

        setLoading(true);
        try {
            // Handle both array of IDs and array of objects
            const selectedIds = selectedRows.map(row => typeof row === 'object' ? row.id : row);
            
            // Get the selected rows from filteredAndSortedData
            const rows = filteredAndSortedData.filter(row => selectedIds.includes(row.id));

            // Filter out rows without valid documentUrl (exclude NoDocumentsPdf)
            const validRows = rows.filter(row => row.documentUrl && row.documentUrl !== NoDocumentsPdf);

            if (validRows.length === 0) {
                toast.info(t('NoDocumentsFound'));
                setLoading(false);
                return;
            }

            const urls = validRows.map(r => r.documentUrl);

            // Merge PDFs
            const merged = await PDFDocument.create();
            for (const url of urls) {
                try {
                    const bytes = await fetch(url).then(r => r.arrayBuffer());
                    const srcPdf = await PDFDocument.load(bytes);
                    const pages = await merged.copyPages(srcPdf, srcPdf.getPageIndices());
                    pages.forEach(p => merged.addPage(p));
                } catch (err) {
                    console.error(`Error loading PDF from ${url}:`, err);
                    // Continue with other PDFs even if one fails
                }
            }

            // Check if we have any pages in the merged document
            if (merged.getPageCount() === 0) {
                toast.error(t('NoDocumentsFound'));
                setLoading(false);
                return;
            }

            // Create blob and download
            const mergedPdfBytes = await merged.save();
            const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            // Create download link
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `merged_documents_${new Date().getTime()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up
            setTimeout(() => {
                URL.revokeObjectURL(blobUrl);
            }, 100);

            toast.success(t('DocumentsDownloaded'));
        } catch (err) {
            console.error('Error merging/downloading documents:', err);
            toast.error(t('MergeOrPrintFailed'));
        } finally {
            setLoading(false);
        }
    };

    const closeDownloadModal = () => {
        setShowDownloadModal(false);
    };

    const handleRightClickAction = async (id, status, editedItem) => {

        if (userTypeContext?.toString() === Constants.UserType.Client && !permissionsState.Premium) {
            return;
        }

        if (status == 'done') {
            await handleDoneClick(id);
        }
        else if (status == 'notDone') {
            await handleNotDoneClick(id)
        }
        fetchByDocumentType(editedItem.documentType);
    };
    const CustomInput2 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="edit-custom-input" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));
    const handleOtherDocumentType = (selectedOption) => {
        if (selectedOption.value1 === 'AddItem') {
            setAddOtherDocumentType(true);
            setDocumentType("")
        } else {
            setDocumentType(selectedOption.value)
        }
    };

    const handleSortChange = (key, type, Direction = '') => {
        let direction = Direction || 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction, type });
    };

    // table functions
    const headerStyle = {
        backgroundColor: '#f7f7f7',
        color: 'black',
        fontWeight: 'bold'
    }

    const [openedIframeUrl, setOpenedIframeUrl] = useState('');
    const [bigIframeModalOpen, setBigIframeModalOpen] = useState(false);
    const openPdfInNewTab = (pdfUrl) => {
        // window.open(pdfUrl, '_blank');

        setOpenedIframeUrl(pdfUrl ? pdfUrl : NoDocumentsPdf);
        setBigIframeModalOpen(true);
    };
    const handleCloseIframeModal = () => {
        setBigIframeModalOpen(false);
        setOpenedIframeUrl('');
    };

    const handleSelectRows = (ids) => {
        if (ids && ids.length === 0) {
            setSelectedRows([]);
            return
        }
        setSelectedRows(ids);
        // let newSelected = [...selectedRows]; // Start with the current selected IDs

        // ids.forEach((id) => {
        //     // Find the item in filteredAndSortedData that matches the selected id
        //     const item = filteredAndSortedData.find((row) => row.id === id);
        //     if (!item) return; // Skip if the item with the given id isn't found


        //     // Check if the id is already in selectedRows
        //     const selectedIndex = newSelected.indexOf(id);

        //     // Add or remove the id based on its presence in selectedRows
        //     if (selectedIndex === -1) {
        //         // ID is not selected, so add it
        //         newSelected.push(id);
        //     } else {
        //         // ID is selected, so remove it
        //         newSelected.splice(selectedIndex, 1);
        //     }
        // });

        // setSelectedRows(newSelected);
    };


    // useEffect(() => {
    //     // Calculate the width as 70% of the container width minus 20px
    //     const containerWidth = document.querySelector('.table-container').offsetWidth;
    //     const newWidth = (containerWidth * 0.7) - 20;
    //     setCalculatedWidth(newWidth + 'px');
    // }, []);

    const handleToggleIframe = () => {
        setShowPdfIframe((prev) => !prev);
    };

    const deleteAfterTransfer = async () => {
        const toDelete = deleteDtos.length > 0
            ? deleteDtos
            : (deleteDto?.id && deleteDto?.fromType ? [deleteDto] : []);

        for (const item of toDelete) {
            try {
                const deleteResponse = await DocumentService.DeleteDocument(item.fromType, item.id, token);
                if (deleteResponse.ok) {
                    toast.success(t('SourceDocumentDeleted'));
                } else {
                    const errorText = await deleteResponse.text();
                    toast.error(t('ErrorDeletingSourceDocument', { errorText }));
                }
            } catch (deleteError) {
                console.error('Error deleting source document:', deleteError);
                toast.error(t('ErrorDeletingSourceDocument', { errorText: deleteError.message }));
            }
        }

        setShouldDelete(false);
        setDeleteDto({});
        setDeleteDtos([]);
    }


    useEffect(() => {
        const transferredKey = 'hasTransferredOtherDocuments';
        const multiTransferredKey = 'hasMultiTransferredOtherDocuments';
        const transferred = sessionStorage.getItem(transferredKey) || false;
        const multiTransferred = sessionStorage.getItem(multiTransferredKey) || false;

        // Multi-transfer destination entry
        if (
            client &&
            !multiTransferred &&
            location.state?.isMultiTransfer &&
            Array.isArray(location.state?.transferItems) &&
            location.state.transferItems.length > 0
        ) {
            const { transferItems } = location.state;
            const allFiles = transferItems.flatMap((item) =>
                Array.isArray(item.files) ? item.files : (item.files ? [item.files] : [])
            );
            setFileTransported(allFiles);
            setMultiTransferItems(transferItems);

            const pendingDeletes = transferItems
                .filter((item) => item.idToDelete && item.fileTypeToDelete)
                .map((item) => ({ id: item.idToDelete, fromType: item.fileTypeToDelete }));

            if (pendingDeletes.length > 0) {
                setShouldDelete(true);
                setDeleteDtos(pendingDeletes);
                setDeleteDto({});
            } else {
                setShouldDelete(false);
                setDeleteDtos([]);
                setDeleteDto({});
            }

            setModalVisible(true);
            sessionStorage.setItem(multiTransferredKey, 'true');
            return;
        }

        if (
            client &&
            !transferred &&
            location.state &&
            location.state.fileTransported &&
            location.state.dto &&
            !location.state.isMultiTransfer
        ) {
            const { fileTransported, dto, idToDelete, fileTypeToDelete } = location.state;
            setFileTransported(fileTransported);
            setMultiTransferItems(null);
            
            // Only set shouldDelete if user confirmed in the Swal
            if (idToDelete && fileTypeToDelete) {
                setShouldDelete(true);
                setDeleteDto({ id: idToDelete, fromType: fileTypeToDelete });
                setDeleteDtos([]);
            } else {
                setShouldDelete(false);
                setDeleteDto({});
                setDeleteDtos([]);
            }
            
            setModalVisible(true);
            sessionStorage.setItem(transferredKey, 'true');
        }
    }, [client, location.state]);

    const RefreshPage = () => {
        handleCancel();
        fetchByDocumentType(documentType);
    }

    useEffect(() => {
        document.body.appendChild(container);
        return () => {
            try {
                document.body.removeChild(container);
            } catch (e) {
                // Ignore
            }
        };
    }, [container]);

    const fileInputRef = useRef();
    const canSeeBulkActions =
        !hideStatusBadge &&
        (userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium);

    const buttonData = [
        {
            label: 'Downloads',
            isDropdown: true,
            iconColor: 'green',
            dropdownItems: [
                {
                    label: 'DownloadDocuments',
                    onClick: () => setShowDownloadModal(true),
                },
                {
                    label: 'DownloadSelectedDocuments',
                    onClick: () => handleDownloadMergedDocuments(),
                    tooltip: selectedRows.length > 0
                        ? `${t('DownloadSelectedDocuments')} (${selectedRows.length})`
                        : t('DownloadSelectedDocuments'),
                    disabled: selectedRows.length === 0 || loading,
                    show: canSeeBulkActions,
                },
            ],
        },
        {
            label: 'Actions',
            isDropdown: true,
            iconColor: 'green',
            dropdownItems: [
                {
                    label: 'UploadDocuments',
                    onClick: () => setModalVisible(true),
                    icon: PostAddIcon,
                },
                {
                    label: 'OpenOptions',
                    onClick: setOpenOption,
                    disabled: selectedRows.length === 0,
                    show: canSeeBulkActions,
                },
                {
                    label: 'AddCategory',
                    onClick: openAddCategoryModal,
                    icon: CreateNewFolderIcon,
                    show: isAccountantOrSubAccountant,
                },
                {
                    label: 'AddTitle',
                    onClick: () => setAddTitleModalOpen(true),
                    icon: FolderSpecialIcon,
                    show: isAccountantOrSubAccountant,
                },
                {
                    label: 'AddPermanentFileAsCategory',
                    onClick: handleConvertPermanentFile,
                    icon: FolderSpecialIcon,
                    disabled: loading,
                    show: isAccountantOrSubAccountant && isPermenantCase && !currentTitleId,
                },
                {
                    label: 'ManageCategories',
                    onClick: () => setManageTitlesOpen(true),
                    icon: SettingsSuggestIcon,
                    show: isAccountantOrSubAccountant,
                },
                {
                    label: 'AssignToTitle',
                    onClick: openAssignTitleModal,
                    icon: DriveFileMoveIcon,
                    show: isAccountantOrSubAccountant,
                },
                {
                    label: currentTitle?.hiddenFromClient ? 'ShowTitleToClient' : 'HideTitleFromClient',
                    onClick: handleToggleCurrentTitleHidden,
                    icon: currentTitle?.hiddenFromClient ? VisibilityIcon : VisibilityOffIcon,
                    disabled: loading,
                    show: isAccountantOrSubAccountant && !!currentTitle,
                },
            ],
        },
    ];

    const typeFilterOptions = (() => {
        const options = [
            { value: t('All'), label: t('All') },
            ...selectOtherDocumentsOptions.map((option) => ({ value: option.name, label: option.name })),
        ];
        const current = documentTypeFetch || t('All');
        if (!options.some((option) => option.value === current)) {
            options.push({ value: current, label: current });
        }
        return options;
    })();
    const selectedTypeFilter = typeFilterOptions.find((option) => option.value === (documentTypeFetch || t('All')));

    const titleSelectOptions = [
        { value: '', label: t('DefaultSection') },
        ...otherDocumentsTitles.map((title) => ({ value: title.id, label: title.name })),
    ];

    const assignTypeOptions = allOtherDocumentsOptions
        .filter((type) => type?.id)
        .map((type) => ({
            value: type.id,
            label: titleNameByType[type.name] ? `${type.name} (${titleNameByType[type.name]})` : type.name,
        }));

    const dialogInputProps = {
        disableUnderline: true,
        sx: {
            height: '48px',
            padding: '0 10px',
            borderRadius: '8px',
            background: '#F5F5F6',
            border: '1px solid transparent',
            '&:focus-within': {
                border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
            },
        },
    };

    const renderTitleSelect = (labelId, value, onChange) => (
        <FormControl fullWidth size="small" sx={{ marginTop: '12px' }}>
            <InputLabel id={labelId}>{t('OtherDocumentsTitle')}</InputLabel>
            <MuiSelect
                labelId={labelId}
                value={value}
                label={t('OtherDocumentsTitle')}
                onChange={(e) => onChange(e.target.value)}
                dir={direction}
                displayEmpty
            >
                {titleSelectOptions.map((option) => (
                    <MenuItem key={option.value || 'default'} value={option.value} dir={direction}>
                        {option.label}
                    </MenuItem>
                ))}
            </MuiSelect>
        </FormControl>
    );

    return (
        <>

            <DraggableModal
                bigIframeModalOpen={bigIframeModalOpen}
                openedIframeUrl={openedIframeUrl}
                handleCloseIframeModal={handleCloseIframeModal}
            />

            <>
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }} dir={direction}>
                        <NavigationButton
                            t={t}
                            direction={direction}
                            selectedRows={selectedRows}
                            fileInputRef={fileInputRef}
                            data={buttonData}
                        />
                    </Box>

                    <div className={`searchFilter-bar__container ${pageStyles.toolbarRow} ${direction}`}>
                        <Box className={pageStyles.filterRow} dir={direction}>
                            <TextField
                                size="small"
                                dir={direction}
                                placeholder={t('searchDocuments')}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className={pageStyles.searchBar}
                                variant="standard"
                                InputProps={{
                                    disableUnderline: true,
                                    className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon className={pageStyles.searchIcon} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <div className={pageStyles.typeField}>
                                <div className={pageStyles.typeFieldTitle}>{t('otherDocumnets type')}</div>
                                <Autocomplete
                                    className={journalFieldStyles.combo}
                                    size="small"
                                    options={typeFilterOptions}
                                    getOptionLabel={(option) => option?.label || ''}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    value={selectedTypeFilter}
                                    onChange={(event, newValue) => {
                                        fetchByDocumentType(newValue?.value || t('All'));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder={t('otherDocumnets type')}
                                            variant="standard"
                                            className={pageStyles.typeInput}
                                            InputProps={{
                                                ...params.InputProps,
                                                disableUnderline: true,
                                            }}
                                            inputProps={{
                                                ...params.inputProps,
                                                style: { textAlign: direction === 'ltr' ? 'left' : 'right' },
                                            }}
                                        />
                                    )}
                                    PopperComponent={(props) => <TypeComboPopper {...props} direction={direction} />}
                                    disableClearable
                                    disableListWrap
                                    fullWidth
                                />
                            </div>
                            <label className={`${headerStyles.switchRow} ${headerStyles[direction] || ''}`} dir={direction}>
                                <span>{t('DateRange')}</span>
                                <input
                                    type="checkbox"
                                    checked={filterByDateRange}
                                    onChange={() => setFilterByDateRange((prev) => !prev)}
                                />
                                <span className={headerStyles.switchTrack} aria-hidden="true" />
                            </label>
                            {filterByDateRange && (
                                <div className={headerStyles.dateSelectRange}>
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={filterStartDate}
                                            month={filterStartDate}
                                            onYearChange={(newYear) => handleFilterDateChange(setFilterStartDate, filterStartDate)(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleFilterDateChange(setFilterStartDate, filterStartDate)(newMonth, 'month')}
                                            labelYear={t('StartYear')}
                                            labelMonth={t('StartMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                    <div className={headerStyles.rangeDivider} />
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={filterEndDate}
                                            month={filterEndDate}
                                            onYearChange={(newYear) => handleFilterDateChange(setFilterEndDate, filterEndDate)(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleFilterDateChange(setFilterEndDate, filterEndDate)(newMonth, 'month')}
                                            labelYear={t('EndYear')}
                                            labelMonth={t('EndMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                </div>
                            )}
                        </Box>
                        {currentTitle && (
                            <Box className={pageStyles.titleBadges} dir={direction}>
                                <span className={pageStyles.titleBadge}>
                                    <FolderSpecialIcon sx={{ fontSize: 16 }} />
                                    {currentTitle.name}
                                </span>
                                {currentTitle.hiddenFromClient && isAccountantOrSubAccountant && (
                                    <span className={`${pageStyles.titleBadge} ${pageStyles.titleBadgeHidden}`}>
                                        <VisibilityOffIcon sx={{ fontSize: 16 }} />
                                        {t('HiddenFromClient')}
                                    </span>
                                )}
                            </Box>
                        )}
                    </div>

                    {modalVisible && (
                        <OtherDocumentCreateModal
                            modalVisible={modalVisible}
                            closeCreateModal={() => setModalVisible(false)}
                            t={t}
                            direction={direction}
                            selectOtherDocumentsOptions={allOtherDocumentsOptions}
                            handleSave={handleSave}
                            fileTransported={fileTransported}
                            canCreateCategory={isAccountantOrSubAccountant}
                        />
                    )}

                    {showDownloadModal && (
                        <OtherDocumentDownloadModal
                            modalVisible={showDownloadModal}
                            closeModal={() => setShowDownloadModal(false)}
                            t={t}
                            direction={direction}
                            selectOtherDocumentsOptions={selectOtherDocumentsOptions}
                            handleDownloadDocuments={handleDownloadDocuments}
                        />
                    )}
                    {!hideStatusBadge && (
                        <Dialog open={openOptions} onClose={closeOptions}>
                            <StyledDialogTitle>{t('SelectOption')}</StyledDialogTitle>
                            <StyledDialogContent>
                                <Typography variant="body2" color="#025366">{t('PleaseSelectOptionForSelectedRows')}</Typography>
                                <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="center" mt={2}>
                                    <OptionButton onClick={() => handleOptionSelect('notDone')}>
                                        {t('unprocessed')}
                                    </OptionButton>
                                    <OptionButton onClick={() => handleOptionSelect('done')}>
                                        {t('processed')}
                                    </OptionButton>
                                    {/* Add more OptionButtons here if needed */}
                                </Box>
                            </StyledDialogContent>
                            <StyledDialogActions>
                                <StyledButtonSecondary onClick={closeOptions}>
                                    {t('close')}
                                </StyledButtonSecondary>
                            </StyledDialogActions>
                        </Dialog>
                    )}

                    {isAccountantOrSubAccountant && (
                        <Dialog open={addCategoryModalOpen} onClose={closeAddCategoryModal} dir={direction}>
                            <StyledDialogTitle>{t('AddCategory')}</StyledDialogTitle>
                            <StyledDialogContent>
                                <Typography variant="body2" color="#025366" sx={{ marginBottom: '12px' }}>
                                    {t('AddCategoryDescription')}
                                </Typography>
                                <TextField
                                    fullWidth
                                    autoFocus
                                    placeholder={t('DocumentTypeName')}
                                    value={newCategoryName}
                                    onChange={(e) => setNewCategoryName(e.target.value)}
                                    variant="standard"
                                    InputProps={{
                                        disableUnderline: true,
                                        sx: {
                                            height: '48px',
                                            padding: '0 10px',
                                            borderRadius: '8px',
                                            background: '#F5F5F6',
                                            border: '1px solid transparent',
                                            '&:focus-within': {
                                                border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
                                            },
                                        },
                                    }}
                                    inputProps={{
                                        style: { textAlign: direction === 'ltr' ? 'left' : 'right' },
                                    }}
                                />
                                <FormControlLabel
                                    sx={{ marginTop: '12px', width: '100%', justifyContent: 'flex-start', marginLeft: 0 }}
                                    control={
                                        <Checkbox
                                            checked={newCategoryHidden}
                                            onChange={(e) => setNewCategoryHidden(e.target.checked)}
                                        />
                                    }
                                    label={t('HideCategoryFromClient')}
                                />
                                {renderTitleSelect('add-category-title-label', newCategoryTitleId, setNewCategoryTitleId)}
                            </StyledDialogContent>
                            <StyledDialogActions>
                                <StyledButton onClick={handleAddCategorySave} disabled={!newCategoryName.trim() || loading}>
                                    {t('save')}
                                </StyledButton>
                                <StyledButtonSecondary onClick={closeAddCategoryModal}>
                                    {t('close')}
                                </StyledButtonSecondary>
                            </StyledDialogActions>
                        </Dialog>
                    )}

                    {isAccountantOrSubAccountant && (
                        <Dialog open={addTitleModalOpen} onClose={closeAddTitleModal} dir={direction}>
                            <StyledDialogTitle>{t('AddTitle')}</StyledDialogTitle>
                            <StyledDialogContent>
                                <Typography variant="body2" color="#025366" sx={{ marginBottom: '12px' }}>
                                    {t('AddTitleDescription')}
                                </Typography>
                                <TextField
                                    fullWidth
                                    autoFocus
                                    placeholder={t('TitleName')}
                                    value={newTitleName}
                                    onChange={(e) => setNewTitleName(e.target.value)}
                                    variant="standard"
                                    InputProps={dialogInputProps}
                                    inputProps={{
                                        style: { textAlign: direction === 'ltr' ? 'left' : 'right' },
                                    }}
                                />
                                <FormControlLabel
                                    sx={{ marginTop: '12px', width: '100%', justifyContent: 'flex-start', marginLeft: 0 }}
                                    control={
                                        <Checkbox
                                            checked={newTitleHidden}
                                            onChange={(e) => setNewTitleHidden(e.target.checked)}
                                        />
                                    }
                                    label={t('HideTitleFromClient')}
                                />
                            </StyledDialogContent>
                            <StyledDialogActions>
                                <StyledButton onClick={handleAddTitleSave} disabled={!newTitleName.trim() || loading}>
                                    {t('save')}
                                </StyledButton>
                                <StyledButtonSecondary onClick={closeAddTitleModal}>
                                    {t('close')}
                                </StyledButtonSecondary>
                            </StyledDialogActions>
                        </Dialog>
                    )}

                    {isAccountantOrSubAccountant && manageTitlesOpen && (
                        <Dialog open onClose={() => setManageTitlesOpen(false)} dir={direction} fullWidth maxWidth="md">
                            <StyledDialogContent sx={{ paddingTop: '16px' }}>
                                <OtherDocumentsTitlesCard
                                    t={t}
                                    direction={direction}
                                    styles={accountantDetailsStyles}
                                    user={user}
                                    token={token}
                                    types={allOtherDocumentsOptions}
                                    onTypesChanged={refreshSection}
                                    onTitlesChanged={reloadTitles}
                                />
                            </StyledDialogContent>
                            <StyledDialogActions>
                                <StyledButtonSecondary onClick={() => setManageTitlesOpen(false)}>
                                    {t('close')}
                                </StyledButtonSecondary>
                            </StyledDialogActions>
                        </Dialog>
                    )}

                    {isAccountantOrSubAccountant && (
                        <Dialog open={assignTitleModalOpen} onClose={closeAssignTitleModal} dir={direction} fullWidth maxWidth="sm">
                            <StyledDialogTitle>{t('AssignToTitle')}</StyledDialogTitle>
                            <StyledDialogContent>
                                <Typography variant="body2" color="#025366" sx={{ marginBottom: '12px' }}>
                                    {t('AssignToTitleDescription')}
                                </Typography>
                                <AutocompleteSelect
                                    options={assignTypeOptions}
                                    selectedValues={assignTypeOptions.filter((option) => assignTypeIds.includes(option.value))}
                                    onChange={(event, newValue) => {
                                        setAssignTypeIds((newValue || []).map((option) => option.value));
                                    }}
                                    label={t('SelectDocumentTypes')}
                                    placeholder={t('SelectDocumentTypes')}
                                    isMultiple={true}
                                    direction={direction}
                                    width="100%"
                                />
                                {renderTitleSelect('assign-title-label', assignTargetTitleId, setAssignTargetTitleId)}
                            </StyledDialogContent>
                            <StyledDialogActions>
                                <StyledButton onClick={handleAssignTitleSave} disabled={assignTypeIds.length === 0 || loading}>
                                    {t('save')}
                                </StyledButton>
                                <StyledButtonSecondary onClick={closeAssignTitleModal}>
                                    {t('close')}
                                </StyledButtonSecondary>
                            </StyledDialogActions>
                        </Dialog>
                    )}

                    <OtherDocumentDataGrid
                        t={t}
                        data={filteredAndSortedData}
                        subAccountantOptions={subAccountantOptions}
                        client={client}
                        openPdfInNewTab={openPdfInNewTab}
                        handleEdit={handleEdit}
                        handleDeleteClick={handleDeleteClick}
                        handleSelectRows={handleSelectRows}
                        handleUpdate={handleUpdate}
                        handleCancel={handleCancel}
                        selectOtherDocumentsOptions={allOtherDocumentsOptions}
                        direction={direction}
                        ref={dataGridRef}
                        setCurrentRowData={setCurrentRowData}
                        setOpenInlineEditModal={setOpenInlineEditModal}
                        handleRightClickAction={handleRightClickAction}
                        permissionsState={permissionsState}
                        userTypeContext={userTypeContext}
                        hideStatus={hideStatusBadge}
                        titleNameByType={titleNameByType}
                    />
                </>
                <CustomDeleteConfirmationModal
                    isVisible={isModalVisible}
                    onClose={() => setIsModalVisible(false)}
                    onDelete={handleConfirmDelete}
                />
                <ToastContainer position={direction === 'rtl' ? 'top-left' : 'top-right'} rtl={direction === 'rtl'} />
                {loading && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Larger size for better visibility
                            loading={loading}
                        />
                    </div>
                )}
                {openInlineEditModal && (
                    <OtherDocumentDraggableDialog
                        open={openInlineEditModal}
                        onClose={() => setOpenInlineEditModal(false)}
                        data={currentRowData}
                        onSave={handleUpdateV2}
                        selectOtherDocumentsOptions={allOtherDocumentsOptions}
                        direction={direction}
                    />
                )}

                {(editedItem && editedPopupItem && Object.keys(editedItem).length > 0) && (
                    <Portal container={container}>
                        <Draggable handle=".handle" nodeRef={nodeRef}>
                            <div
                                ref={nodeRef}
                                style={{
                                    position: 'absolute',
                                    top: '10%',
                                    left: '20%',
                                    transform: 'translate(-50%, -50%)',
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    minHeight: '76vh',
                                    maxHeight: '90vh',
                                    overflowY: 'auto',
                                    // Adjust the width based on showIframe
                                    minWidth: showPdfIframe ? '1200px' : '700px',
                                    zIndex: 1300,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    direction: direction,
                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.4)', // Adds shadow
                                    border: '1px solid #304fff',
                                }}
                            >
                                {/* Document (Iframe) */}


                                {/* Form Content */}
                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    {/* Header with Draggable Handle */}
                                    <div
                                        className="handle"
                                        style={{
                                            cursor: 'move',
                                            fontSize: '20px',
                                            fontWeight: 'bold',
                                            marginBottom: '16px',
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        {
                                            (userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium) &&
                                            <>
                                                <div>
                                                    <DocumentTransferDialog
                                                        editedItem={editedItem}
                                                        token={token}
                                                        setLoading={setLoading}
                                                        RefreshPage={RefreshPage}
                                                        t={t}
                                                        client={client}
                                                    />
                                                </div>
                                            </>
                                        }
                                        {/* Title and Navigation Buttons */}
                                        <div
                                            className="edit-title-container"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                margin: '0 auto',
                                            }}
                                        >
                                            {/* Next Button */}
                                            {currentIndex !== filteredAndSortedData.length - 1 && (
                                                <div
                                                    className={`backIconBackground-edit ${currentIndex === filteredAndSortedData.length - 1
                                                        ? 'pointer-events-disable'
                                                        : ''
                                                        }`}
                                                    onClick={handleNext}
                                                >
                                                    {/* Next arrow SVG */}
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M9.00047 15.875L12.8805 11.995L9.00047 8.11498C8.61047 7.72498 8.61047 7.09498 9.00047 6.70498C9.39047 6.31498 10.0205 6.31498 10.4105 6.70498L15.0005 11.295C15.3905 11.685 15.3905 12.315 15.0005 12.705L10.4105 17.295C10.0205 17.685 9.39047 17.685 9.00047 17.295C8.62047 16.905 8.61047 16.265 9.00047 15.875Z"
                                                            fill="black"
                                                            fillOpacity="0.9"
                                                        />
                                                    </svg>
                                                </div>
                                            )}
                                            {/* Title */}
                                            <div className="edit-title">
                                                {t('Document')} {editedItem.uploadNumber}
                                            </div>
                                            {/* Previous Button */}
                                            {currentIndex !== 0 && (
                                                <div
                                                    className={`backIconBackground-edit ${currentIndex === 0 ? 'pointer-events-disable' : ''
                                                        }`}
                                                    onClick={handlePrevious}
                                                >
                                                    {/* Previous arrow SVG */}
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M14.9995 15.875L11.1195 11.995L14.9995 8.11498C15.3895 7.72498 15.3895 7.09498 14.9995 6.70498C14.6095 6.31498 13.9795 6.31498 13.5895 6.70498L8.99953 11.295C8.60953 11.685 8.60953 12.315 8.99953 12.705L13.5895 17.295C13.9795 17.685 14.6095 17.685 14.9995 17.295C15.3795 16.905 15.3895 16.265 14.9995 15.875Z"
                                                            fill="black"
                                                            fillOpacity="0.9"
                                                        />
                                                    </svg>
                                                </div>
                                            )}

                                        </div>
                                        {/* Visibility Toggle */}
                                        <div>
                                            <IconButton onClick={handleToggleIframe}>
                                                {showPdfIframe ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                            </IconButton>
                                        </div>

                                    </div>

                                    {/* Modal Content */}
                                    <div className={`form-container ${direction}`}>
                                        {/* Form Rows */}
                                        {/* Example: Row 1 */}
                                        <div className="form-row">
                                            {/* Title Field */}
                                            <div className="edit-form-row-item">
                                                <div className="edit-form-row-item-title">
                                                    {t('Title')}
                                                    <span className="required-asterisk">*</span>
                                                </div>
                                                <TextField
                                                    fullWidth
                                                    placeholder={t('Title')}
                                                    value={editedItem.title || ''}
                                                    onChange={(e) => handleChange(e, 'title')}
                                                    variant="standard"
                                                    InputProps={{
                                                        disableUnderline: true,
                                                        style: {
                                                            height: '48px',
                                                            padding: '0 10px',
                                                            borderRadius: '8px',
                                                            background: '#F5F5F6',
                                                            border: '1px solid transparent',
                                                        },
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            textAlign: direction === 'ltr' ? 'left' : 'right',
                                                        },
                                                    }}
                                                    required
                                                />
                                            </div>

                                            {/* Document Type Field */}
                                            <div className="edit-form-row-item">
                                                <div className="edit-form-row-item-title">
                                                    {t('Document Type')}
                                                    <span className="required-asterisk">*</span>
                                                </div>
                                                <Autocomplete
                                                    options={allOtherDocumentsOptions.map(option => ({
                                                        value: option.name,
                                                        label: option.name,
                                                    }))}
                                                    getOptionLabel={(option) => option.label}
                                                    value={
                                                        allOtherDocumentsOptions
                                                            .map(option => ({ value: option.name, label: option.name }))
                                                            .find(option => option.value === editedItem.documentType) || null
                                                    }
                                                    onChange={(event, newValue) => {
                                                        const newDocumentType = newValue ? newValue.value : '';
                                                        setEditedItem({ ...editedItem, documentType: newDocumentType });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder={t('otherDocumnets type')}
                                                            variant="standard"
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                ...inputPropsStyle, // Use your predefined input style here
                                                            }}
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                ...inputStyle, // Use your predefined input style here
                                                            }}
                                                            required
                                                        />
                                                    )}
                                                    PopperComponent={(props) => (
                                                        <StyledPopper
                                                            {...props}
                                                            style={{
                                                                ...props.style,
                                                                direction: direction, // Use your predefined direction here
                                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.7)',
                                                            }}
                                                        />
                                                    )}
                                                />

                                            </div>
                                        </div>
                                        {
                                            (userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium) &&
                                            <>
                                                <div className="edit-form-row-item" >
                                                    <div className="edit-form-row-item-title" style={{ marginRight: '16px' }}>
                                                        {t('status')}
                                                        <span className="required-asterisk">*</span>
                                                    </div>
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="demo-form-control-label-placement"
                                                        name="position"
                                                        defaultValue="top"
                                                        onChange={handleRadioChange}
                                                        sx={{
                                                            height: '48px',
                                                            padding: '0 10px',
                                                            borderRadius: '8px',
                                                            background: '#F5F5F6',
                                                            justifyContent: 'center',
                                                            gap: '30px',
                                                            border: '1px solid transparent',
                                                            '&:focus-within': {
                                                                border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
                                                            },
                                                        }}
                                                    >
                                                        <FormControlLabel
                                                            value="notDone"
                                                            control={<Radio style={{ height: '48px', padding: '0 8px' }} />}
                                                            label={t('unprocessed')}
                                                            labelPlacement="top"
                                                            checked={!statusCheck}
                                                            style={{ margin: 0, height: '48px' }}
                                                        />
                                                        <FormControlLabel
                                                            value="done"
                                                            control={<Radio style={{ height: '48px', padding: '0 8px' }} />}
                                                            label={t('processed')}
                                                            labelPlacement="top"
                                                            checked={statusCheck}
                                                            style={{ margin: 0, height: '48px' }}
                                                        />
                                                    </RadioGroup>
                                                </div>
                                            </>
                                        }
                                        {/* Buttons */}
                                        <div className="edit-buttons-container" style={{ marginTop: '16px' }}>
                                            <StyledButton onClick={handleUpdate}>
                                                {t('save')}
                                            </StyledButton>
                                            <StyledButtonSecondary onClick={handleCancel}>
                                                {t('close')}
                                            </StyledButtonSecondary>
                                        </div>
                                    </div>
                                </div>

                                {showPdfIframe && (
                                    <div style={{ flex: 1 }}>
                                        <Iframe
                                            url={
                                                editedItem.documentUrl
                                                    ? `${editedItem.documentUrl}#page=1&view=FitH`
                                                    : `${NoDocumentsPdf}#page=1&view=FitH`
                                            }
                                            width="100%"
                                            height="100%"
                                            id={editedItem.id}
                                            position="relative"
                                            title={editedItem.title}
                                            allowFullScreen
                                        />
                                    </div>
                                )}
                            </div>
                        </Draggable>



                    </Portal>
                )}

            </>

        </>
    );
}


export default Document;
